<style>.testimonial {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  min-height: 100%;
  padding: 1em;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.testimonial p {
  font-size: 1rem;
}

.testimonial strong {
  font-weight: bold;
}</style>
<template><div class="testimonial">
    <p>
        "{{text}}"
        <br />
        <strong>- {{name}}</strong>
    </p>
</div></template>
<script>export default {
    props: {
        text: {
            title: 'Recension',
            type: String,
            default: ''
        },
        name: {
            title: 'Namn',
            type: String,
            default: ''
        }
    }
}</script>